import { FC } from 'react';
import { useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';

const QuickFixModal: FC<
  React.PropsWithChildren<QuickFixModalProps>
> = props => {
  const theme = useTheme();
  const { open, onClose, children, modalHeader } = props;

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label={modalHeader}
      open={open}
      onClose={onClose}
      maxWidth='md'
      modalHeader={modalHeader}>
      {children}
    </ModalDialog>
  );
};

interface QuickFixModalProps {
  open: boolean;
  onClose: () => void;
  modalHeader: string;
}

export default QuickFixModal;
